import { createBrowserRouter } from 'react-router-dom';

import RootLayout from '../components/Layout/RootLayout/RootLayout';
import LocaleProvider from '../context/LocaleContext';
import { HttpStatusE } from '../declarations/enums/httpStatus';
import { RoutesPathE } from '../declarations/enums/routes';
import { CustomerConfigI } from '../declarations/interfaces/customer';
import CarbonOffsetsPage from '../pages/CarbonOffsetsPage/CarbonOffsetsPage';
import ConfirmationPage from '../pages/ConfirmationPage/ConfirmationPage';
import Error404Page from '../pages/Error404Page/Error404Page';
import Error500Page from '../pages/Error500Page/Error500Page';
import HomePage from '../pages/HomePage/HomePage';
import PaymentDetailsPage from '../pages/PaymentDetailsPage/PaymentDetailsPage';
import SustainableActionsPage from '../pages/SustainableActionsPage/SustainableActionsPage';
import ThankYouPage from '../pages/ThankYouPage/ThankYouPage';
import TransportationPage from '../pages/TransportationPage/TransportationPage';

export const CUSTOMER_NAME = window.location.pathname.split('/')[1];

const ErrorBoundary = ({ errorCode }: { errorCode?: HttpStatusE }) => {
  // Based on the logic, it is handled only 2 error cases
  // Because of dynamic url (customer name) it is difficult to navigate by react-router
  // That's why errors render before main route init
  if (errorCode === HttpStatusE.INTERNAL_SERVER_ERROR) {
    return <Error500Page />;
  }

  return <Error404Page />;
};

type AppRouterPropsT = {
  config: CustomerConfigI;
  errorCode?: HttpStatusE;
};

export const AppRouter = ({ config, errorCode }: AppRouterPropsT) =>
  createBrowserRouter(
    [
      {
        path: `/`,
        errorElement: (
          <LocaleProvider>
            <ErrorBoundary errorCode={errorCode} />
          </LocaleProvider>
        ),
        element: <RootLayout config={config} />,
        children: [
          {
            path: RoutesPathE.HOME_PAGE,
            element: <HomePage />,
          },
          {
            path: RoutesPathE.SUSTAINABLE_ACTIONS_PAGE,
            element: <SustainableActionsPage />,
          },
          {
            path: RoutesPathE.CARBON_OFFSETS_PAGE,
            element: <CarbonOffsetsPage />,
          },
          {
            path: RoutesPathE.TRANSPORTATION_PAGE,
            element: <TransportationPage />,
          },
          {
            path: RoutesPathE.PAYMENT_DETAILS_PAGE,
            element: <PaymentDetailsPage />,
          },
          {
            path: RoutesPathE.CONFIRMATION_PAGE,
            element: <ConfirmationPage />,
          },
          {
            path: RoutesPathE.THANK_YOU_PAGE,
            element: <ThankYouPage />,
          },
        ],
      },
    ],
    {
      basename: `/${CUSTOMER_NAME}`,
    }
  );
